import React, { ImgHTMLAttributes } from "react";

type ImageProps = ImgHTMLAttributes<HTMLImageElement>;

const Image: React.FC<ImageProps> = (props) => {
  const onError: React.EventHandler<React.SyntheticEvent<HTMLImageElement, Event>> = (event) => {
    event.currentTarget.src = "https://picsum.photos/id/91/200";
  };

  return <img onError={onError} {...props} />;
};

export default Image;